"use strict";

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNative = require("react-native");

var _react = _interopRequireDefault(require("react"));

var _types = _interopRequireDefault(require("./types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InvalidType = function InvalidType() {
  return _react["default"].createElement(_reactNative.Text, {
    style: {
      margin: 10
    }
  }, "Invalid Type");
};

var Label =
/*#__PURE__*/
_native["default"].Text(function (_ref) {
  var theme = _ref.theme;
  return {
    marginLeft: 10,
    fontSize: 14,
    color: theme.labelColor || 'black',
    fontWeight: 'bold'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Qcm9wRmllbGQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUWMiLCJmaWxlIjoiLi4vc3JjL1Byb3BGaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBWaWV3LCBUZXh0IH0gZnJvbSAncmVhY3QtbmF0aXZlJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL25hdGl2ZSc7XG5pbXBvcnQgVHlwZU1hcCBmcm9tICcuL3R5cGVzJztcblxuY29uc3QgSW52YWxpZFR5cGUgPSAoKSA9PiA8VGV4dCBzdHlsZT17eyBtYXJnaW46IDEwIH19PkludmFsaWQgVHlwZTwvVGV4dD47XG5cbmNvbnN0IExhYmVsID0gc3R5bGVkLlRleHQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogMTAsXG4gIGZvbnRTaXplOiAxNCxcbiAgY29sb3I6IHRoZW1lLmxhYmVsQ29sb3IgfHwgJ2JsYWNrJyxcbiAgZm9udFdlaWdodDogJ2JvbGQnLFxufSkpO1xuXG5jb25zdCBQcm9wRmllbGQgPSAoeyBvbkNoYW5nZSwgb25QcmVzcywga25vYiB9KSA9PiB7XG4gIGNvbnN0IElucHV0VHlwZSA9IFR5cGVNYXBba25vYi50eXBlXSB8fCBJbnZhbGlkVHlwZTtcblxuICByZXR1cm4gKFxuICAgIDxWaWV3PlxuICAgICAgeyFrbm9iLmhpZGVMYWJlbCA/IDxMYWJlbD57YCR7a25vYi5sYWJlbCB8fCBrbm9iLm5hbWV9YH08L0xhYmVsPiA6IG51bGx9XG4gICAgICA8SW5wdXRUeXBlIGtub2I9e2tub2J9IG9uQ2hhbmdlPXtvbkNoYW5nZX0gb25QcmVzcz17b25QcmVzc30gLz5cbiAgICA8L1ZpZXc+XG4gICk7XG59O1xuXG5Qcm9wRmllbGQucHJvcFR5cGVzID0ge1xuICBrbm9iOiBQcm9wVHlwZXMuc2hhcGUoe1xuICAgIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgbGFiZWw6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgdmFsdWU6IFByb3BUeXBlcy5hbnksXG4gICAgaGlkZUxhYmVsOiBQcm9wVHlwZXMuYm9vbCxcbiAgICB0eXBlOiBQcm9wVHlwZXMub25lT2YoW1xuICAgICAgJ3RleHQnLFxuICAgICAgJ251bWJlcicsXG4gICAgICAnY29sb3InLFxuICAgICAgJ2Jvb2xlYW4nLFxuICAgICAgJ29iamVjdCcsXG4gICAgICAnc2VsZWN0JyxcbiAgICAgICdhcnJheScsXG4gICAgICAnZGF0ZScsXG4gICAgICAnYnV0dG9uJyxcbiAgICAgICdyYWRpb3MnLFxuICAgIF0pLFxuICB9KS5pc1JlcXVpcmVkLFxuICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgb25QcmVzczogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFByb3BGaWVsZDtcbiJdfQ== */");

var PropField = function PropField(_ref2) {
  var onChange = _ref2.onChange,
      onPress = _ref2.onPress,
      knob = _ref2.knob;
  var InputType = _types["default"][knob.type] || InvalidType;
  return _react["default"].createElement(_reactNative.View, null, !knob.hideLabel ? _react["default"].createElement(Label, null, "".concat(knob.label || knob.name)) : null, _react["default"].createElement(InputType, {
    knob: knob,
    onChange: onChange,
    onPress: onPress
  }));
};

PropField.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    label: _propTypes["default"].string,
    value: _propTypes["default"].any,
    hideLabel: _propTypes["default"].bool,
    type: _propTypes["default"].oneOf(['text', 'number', 'color', 'boolean', 'object', 'select', 'array', 'date', 'button', 'radios'])
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onPress: _propTypes["default"].func.isRequired
};
var _default = PropField;
exports["default"] = _default;